import { Flex } from 'antd';
import yogaPicture from '../../../assets/imgs/yoga.jpg';
import styles from '../navbar.module.scss';
import { CareIcon, ConnectedIcon, MedicalCareIcon, TrackLandingIcon } from '../../../common/all-icons/custom-icons';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: <MedicalCareIcon />,
      title: 'Get personalized medical care',
      desc: 'Board-certified doctors review your health profile and create a plan tailored specifically to your goals and needs',
    },
    {
      icon: <TrackLandingIcon />,
      title: 'Track everything in one place',
      desc: 'Monitor your progress, medications, and health metrics through our simple, secure app',
    },
    {
      icon: <ConnectedIcon />,
      title: 'Never feel alone',
      desc: 'Text your care team anytime, get quick responses, and schedule check-ins whenever you need support',
    },
    {
      icon: <CareIcon />,
      title: 'Medications delivered',
      desc: 'Personalized treatments arrive discreetly at your door, with clear instructions and ongoing monitoring',
    },
  ];

  return (
    <div className={styles.benfitsSection}>
      <div className={styles.benefitsWrap}>
        <div className={styles.yoga}>
          <img src={yogaPicture} alt="Yoga" className={styles['yoga-image']} />
        </div>
        <div className={styles.benefitPointWrap}>
          <div className={styles.benefitsHeading}>Here's what happens when you join</div>
          <div className={styles.pointsWrap}>
            {benefits.map((benefit) => {
              return (
                <div className={styles.pointWrap}>
                  {benefit?.icon}
                  <div className={styles.point}>
                    <div className={styles.forthText}>{benefit?.title}</div>
                    <div style={{ color: 'var(--user-main-text)' }} className="body-14-medium">
                      {benefit?.desc}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenefitsSection;
